import { compose } from "redux";
import React, { PureComponent } from "react";
import { Grid, withStyles } from "@material-ui/core";

import { OverviewContainer as AltusOverviewContainer } from "altus-ui-components";

class OverviewContainer extends PureComponent {
  render() {
    const { classes, children, ...rest } = this.props;

    return (
      <Grid container justifyContent="center">
        <Grid item xs={12} md={10}>
          <AltusOverviewContainer
            BasePageProps={{
              classes: {
                root: classes.basePageRoot,
              },
            }}
            {...rest}
          >
            {children}
          </AltusOverviewContainer>
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  basePageRoot: {
    padding: `${theme.spacing(5)}px ${theme.spacing(2)}px`,
  },
});

export default compose(withStyles(styles))(OverviewContainer);
